export enum ConceptoVerificacion {
    TIPO_IDENTIFICACION='TIPO_IDENTIFICACION',
    IDENTIFICACION='IDENTIFICACION',
    PRIMER_NOMBRE='PRIMER_NOMBRE',
    SEGUNDO_NOMBRE='SEGUNDO_NOMBRE',
    PRIMER_APELLIDO='PRIMER_APELLIDO',
    SEGUNDO_APELLIDO='SEGUNDO_APELLIDO',
    FECHA_NACIMIENTO='FECHA_NACIMIENTO',
    SEXO='SEXO',
    CORREO_ELECTRONICO='CORREO_ELECTRONICO',
    NUMERO_CELULAR='NUMERO_CELULAR',
    DEPARTAMENTO_RESIDENCIA='DEPARTAMENTO_RESIDENCIA',
    MUNICIPIO_RESIDENCIA='MUNICIPIO_RESIDENCIA',
    PERFIL_ID='PERFIL_ID',
    DOCUMENTO_IDENTIDAD_ADJUNTO='DOCUMENTO_IDENTIDAD_ADJUNTO',
    TARJETA_PROFESIONAL_ADJUNTO='TARJETA_PROFESIONAL_ADJUNTO',
    CERTIFICADO_CONTRALORIA_ADJUNTO='CERTIFICADO_CONTRALORIA_ADJUNTO',
    CERTIFICADO_ANTECEDENTES_DISCIPLINARIOS_ADJUNTO='CERTIFICADO_ANTECEDENTES_DISCIPLINARIOS_ADJUNTO',
    CERTIFICADO_PROCURADURIA_ADJUNTO='CERTIFICADO_PROCURADURIA_ADJUNTO',
    CERTIFICADO_POLICIA_NACIONAL_ADJUNTO='CERTIFICADO_POLICIA_NACIONAL_ADJUNTO',
    CERTIFICADO_RNMC_ADJUNTO='CERTIFICADO_RNMC_ADJUNTO',
    FORMACIONES_ACADEMICA='FORMACIONES_ACADEMICA',
    EXPERIENCIAS_LABORALES='EXPERIENCIAS_LABORALES',
    FECHA_EXPEDICION_TARJETA_PROFESIONAL='FECHA_EXPEDICION_TARJETA_PROFESIONAL',
    HORARIOS_DISPONIBLES='HORARIOS_DISPONIBLES',
    SEDES_DISPONIBLES='SEDES_DISPONIBLES',
    HOJA_DE_VIDA= 'HOJA_DE_VIDA'
}

export enum TipoCampo {
    TEXTO = "TEXTO",
    SELECT_DPTO ="SELECT_DPTO",
    SELECT_TIPO_DOC ="SELECT_TIPO_DOC",
    SELECT_SEXO ="SELECT_SEXO",
    SELECT_MPIO="SELECT_MPIO",
    SELECT_PERFIL="SELECT_PERFIL",
    FECHA= "FECHA",
    FORMACION_ACADEMICA= "FORMACION_ACADEMICA",
    ADJUNTO = "ADJUNTO",
    EXPERIENCIA_LABORAL = "EXPERIENCIA_LABORAL",
    HORARIOS = "HORARIOS",
    SEDES_DISPONIBLES = "SEDES_DISPONIBLES",
}

export interface IConceptoVerificacion {
    campo: string,
    label: string,
    tipo: TipoCampo,
    campoFecha?: string
}

export type ConceptosVerificacionMap = {
    [key in ConceptoVerificacion]: IConceptoVerificacion;
};


export const ConceptosVerificacionProps: ConceptosVerificacionMap = {
    [ConceptoVerificacion.TIPO_IDENTIFICACION]: { campo: 'tipoIdentificacion', label:'Tipo de identificación', tipo: TipoCampo.SELECT_TIPO_DOC },
    [ConceptoVerificacion.IDENTIFICACION]: { campo: 'identificacion', label:'Número de identificación', tipo: TipoCampo.TEXTO },
    [ConceptoVerificacion.PRIMER_NOMBRE]: { campo: 'primerNombre', label:'Primer nombre', tipo: TipoCampo.TEXTO },
    [ConceptoVerificacion.SEGUNDO_NOMBRE]: { campo: 'segundoNombre', label:'Segundo nombre', tipo: TipoCampo.TEXTO },
    [ConceptoVerificacion.PRIMER_APELLIDO]: { campo: 'primerApellido', label:'Primer apellido', tipo: TipoCampo.TEXTO },
    [ConceptoVerificacion.SEGUNDO_APELLIDO]: { campo: 'segundoApellido' , label:'Segundo apellido', tipo: TipoCampo.TEXTO},
    [ConceptoVerificacion.FECHA_NACIMIENTO]: { campo: 'fechaNacimiento', label:'Fecha de nacimiento', tipo: TipoCampo.FECHA },
    [ConceptoVerificacion.SEXO]: { campo: 'sexo', label:'Sexo', tipo: TipoCampo.SELECT_SEXO },
    [ConceptoVerificacion.CORREO_ELECTRONICO]: { campo: 'correoElectronico', label:'Correo electrónico', tipo: TipoCampo.TEXTO },
    [ConceptoVerificacion.NUMERO_CELULAR]: { campo: 'numeroCelular', label:'Número de celular', tipo: TipoCampo.TEXTO },
    [ConceptoVerificacion.DEPARTAMENTO_RESIDENCIA]: { campo: 'departamentoResidenciaId', label:'Departamento de residencia', tipo: TipoCampo.SELECT_DPTO },
    [ConceptoVerificacion.MUNICIPIO_RESIDENCIA]: { campo: 'municipioResidenciaId', label:'Municipio de residencia', tipo: TipoCampo.SELECT_MPIO },
    [ConceptoVerificacion.PERFIL_ID]: { campo: 'perfilId', label:'Perfil', tipo: TipoCampo.SELECT_PERFIL },
    [ConceptoVerificacion.DOCUMENTO_IDENTIDAD_ADJUNTO]: { campo: 'documentoIdentidadAdjuntoId', label:'Documento de identidad', tipo: TipoCampo.ADJUNTO },
    [ConceptoVerificacion.HOJA_DE_VIDA]: { campo: 'hojaDeVidaAdjuntoId', label:'Hoja de vida', tipo: TipoCampo.ADJUNTO },
    [ConceptoVerificacion.TARJETA_PROFESIONAL_ADJUNTO]: { campo: 'tarjetaProfesionalAdjuntoId', label:'Tarjeta profesional', tipo: TipoCampo.ADJUNTO },
    [ConceptoVerificacion.CERTIFICADO_ANTECEDENTES_DISCIPLINARIOS_ADJUNTO]: { campo: 'certificadoAntecedentesDisciplinariosId', label:'Certificado antecedentes profesionales', tipo: TipoCampo.ADJUNTO, campoFecha:'certificadoAntecedentesDisciplinariosFecha' },
    [ConceptoVerificacion.CERTIFICADO_CONTRALORIA_ADJUNTO]: { campo: 'certificadoContraloriaAdjuntoId' , label:'Certificado contraloria', tipo: TipoCampo.ADJUNTO, campoFecha: 'certificadoContraloriaAdjuntoFecha'},
    [ConceptoVerificacion.CERTIFICADO_PROCURADURIA_ADJUNTO]: { campo: 'certificadoProcuraduriaAdjuntoId', label:'Certificado procuraduria', tipo: TipoCampo.ADJUNTO , campoFecha: 'certificadoProcuraduriaAdjuntoFecha'},
    [ConceptoVerificacion.CERTIFICADO_POLICIA_NACIONAL_ADJUNTO]: { campo: 'certificadoPoliciaNacionalAdjuntoId', label:'Certificado policia nacional', tipo: TipoCampo.ADJUNTO, campoFecha: 'certificadoPoliciaNacionalAdjuntoFecha' },
    [ConceptoVerificacion.CERTIFICADO_RNMC_ADJUNTO]: { campo: 'certificadoRnmcAdjuntoId', label:'Certificado del registro nacional de medidas correctivas', tipo: TipoCampo.ADJUNTO, campoFecha: 'certificadoRnmcAdjuntoFecha' },
    [ConceptoVerificacion.FORMACIONES_ACADEMICA]: { campo: 'formacionesAcademicas', label:'Formación académica', tipo: TipoCampo.FORMACION_ACADEMICA },
    [ConceptoVerificacion.FECHA_EXPEDICION_TARJETA_PROFESIONAL]: { campo: 'fechaExpedicionTarjetaProfesional', label:'Fecha expedición tarjeta profesional', tipo: TipoCampo.FECHA },
    [ConceptoVerificacion.EXPERIENCIAS_LABORALES]: { campo: 'experienciasLaborales', label:'Experiencia Laboral', tipo: TipoCampo.EXPERIENCIA_LABORAL },
    [ConceptoVerificacion.HORARIOS_DISPONIBLES]: { campo: 'horariosDisponibles', label:'Horarios disponibles', tipo: TipoCampo.HORARIOS },
    [ConceptoVerificacion.SEDES_DISPONIBLES]: { campo: 'sedesDisponibles', label:'Sedes disponibles', tipo: TipoCampo.SEDES_DISPONIBLES },
}